// extracted by mini-css-extract-plugin
export default {"block":"styles-module__[local]___BUAkt"};